import { apiMediaUrl, apiPortalUrl, apiUrl, AppConstants, siteSelectionPath } from '.';

const baseHeader = {
    'Content-Type': 'application/json',
};

const multipartFormHeader = {
    'Content-Type': 'multipart/form-data',
};

const apiConfig = {
    account: {
        loginBasic: {
            baseURL: `${apiUrl}api/token`,
            method: 'POST',
            headers: baseHeader,
        },
        loginSSO: {
            baseURL: `${apiUrl}sso/login`,
            method: 'POST',
            headers: baseHeader,
        },
        getProfile: {
            baseURL: `${apiUrl}v1/account/profile`,
            method: 'GET',
            headers: baseHeader,
        },
        // createProfile: {
        //     baseURL: `${apiUrl}v1/account/create-admin`,
        //     method: 'POST',
        //     headers: baseHeader,
        // },
        updateProfile: {
            baseURL: `${apiUrl}v1/account/update_admin`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'ACC_U_AD',
        },
        updateProfileAdmin: {
            baseURL: `${apiUrl}v1/account/update_profile_admin`,
            method: 'PUT',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/account/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'ACC_V',
        },
        logout: {
            baseURL: `${apiUrl}v1/account/logout`,
            method: 'GET',
            headers: baseHeader,
        },
        getList: {
            baseURL: `${apiUrl}v1/account/list`,
            method: `GET`,
            headers: baseHeader,
            permissionCode: 'ACC_L',
        },
        createAdmin: {
            baseURL: `${apiUrl}v1/account/create_admin`,
            method: `POST`,
            headers: baseHeader,
            permissionCode: 'ACC_C_AD',
        },
        updateAdmin: {
            baseURL: `${apiUrl}v1/account/update_admin`,
            method: `PUT`,
            headers: baseHeader,
            permissionCode: 'ACC_U_AD',
        },
        delete: {
            baseURL: `${apiUrl}v1/account/delete/:id`,
            method: `DELETE`,
            headers: baseHeader,
            permissionCode: 'ACC_D',
        },
        getShopAccountProfile: {
            baseURL: `${apiUrl}v1/shop_account/profile`,
            method: 'GET',
            site: siteSelectionPath.authentication,
            headers: baseHeader,
        },
        updateShopAccountProfile: {
            baseURL: `${apiUrl}v1/shop_account/update_profile`,
            method: 'PUT',
            site: siteSelectionPath.authentication,
            headers: baseHeader,
        },
        exportExcel: {
            baseURL: `${apiUrl}v1/account/export-to-excel-key`,
            method: `GET`,
            headers: baseHeader,
        },
        getMyKey: {
            baseURL: `${apiUrl}v1/account/my-key`,
            method: `GET`,
            headers: baseHeader,
        },
        clearKey: {
            baseURL: `${apiUrl}v1/account/clear-key`,
            method: `GET`,
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/account/auto-complete`,
            method: `GET`,
            headers: baseHeader,
        },
        synchronize: {
            baseURL: `${apiUrl}v1/account/synchronize-admin`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'ACC_S',
        },
        changePassword: {
            baseURL: `${apiUrl}v1/account/change-password`,
            method: `PUT`,
            headers: baseHeader,
            // permissionCode: 'ACC_CP',
        },
    },
    user: {
        getList: {
            baseURL: `${apiUrl}v1/user/list`,
            method: `GET`,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/user/get/:id`,
            method: `GET`,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/user/create`,
            method: `POST`,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/user/update`,
            method: `PUT`,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/user/delete/:id`,
            method: `DELETE`,
            headers: baseHeader,
        },

        searchShopAccount: {
            baseURL: `${apiUrl}v1/shop_account/autocomplete`,
            method: 'GET',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/user/auto-complete`,
            method: `GET`,
            headers: baseHeader,
        },
        getShopDatabaseInfo: {
            baseURL: `${apiUrl}v1/db-config/get/:id`,
            method: 'GET',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'DB_V_RES',
        },
        updateShopDatabaseInfo: {
            baseURL: `${apiUrl}v1/db-config/update`,
            method: 'PUT',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'DB_U',
        },
        createShopDatabaseInfo: {
            baseURL: `${apiUrl}v1/db-config/create`,
            method: 'POST',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'DB_C',
        },
    },
    shopAccount: {
        getList: {
            baseURL: `${apiUrl}v1/shop_account/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SHOP_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/shop_account/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SHOP_V',
        },
        create: {
            baseURL: `${apiUrl}v1/shop_account/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'SHOP_C',
        },
        update: {
            baseURL: `${apiUrl}v1/shop_account/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'SHOP_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/shop_account/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'SHOP_D',
        },
    },
    file: {
        download_video_resource: {
            path: `${AppConstants.mediaRootUrl}v1/file/download-video-resource`,
            method: 'GET',
            headers: multipartFormHeader,
        },
        upload_video: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload-video`,
            method: 'POST',
            headers: multipartFormHeader,
            permissionCode: 'FILE_U_V',
        },
        upload: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload`,
            method: 'POST',
            headers: multipartFormHeader,
            permissionCode: 'FILE_U',
            isRequiredTenantId: true,
        },
        getImages: {
            baseURL: `${AppConstants.mediaRootUrl}v1/template-image/list`,
            method: 'GET',
            headers: baseHeader,
        },
        image: {
            path: `${AppConstants.mediaRootUrl}admin/v1/image/upload`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        video: {
            path: `${AppConstants.mediaRootUrl}admin/v1/video/upload`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        uploadApk: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload-apk`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        uploadTemplate: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload-template`,
            method: 'POST',
            headers: multipartFormHeader,
            permissionCode: 'FILE_U_T',
        },
        deleteFile: {
            baseURL: `${AppConstants.mediaRootUrl}v1/file/delete-file`,
            method: 'POST',
            headers: baseHeader,
        },
        appDetails: {
            baseURL: `${AppConstants.mediaRootUrl}v1/file/app-details`,
            method: 'GET',
            headers: baseHeader,
        },
        uploadVersion: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload-version`,
            method: 'POST',
            headers: multipartFormHeader,
        },
        deleteVersion: {
            baseURL: `${AppConstants.mediaRootUrl}v1/file/delete-version`,
            method: 'POST',
            headers: baseHeader,
        },
        uploadMenu: {
            path: `${AppConstants.mediaRootUrl}v1/file/upload-menu`,
            method: 'POST',
            headers: multipartFormHeader,
            isRequiredTenantId: true,
        },
    },
    category: {
        getList: {
            baseURL: `${apiUrl}v1/category/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/category/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/category/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/category/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/category/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/category/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    languages: {
        getList: {
            baseURL: `${apiUrl}admin/v1/languages`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    groupPermission: {
        getGroupList: {
            baseURL: `${apiUrl}v1/group/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'GR_L',
        },
        getList: {
            baseURL: `${apiUrl}v1/group/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'GR_L',
        },
        getPemissionList: {
            baseURL: `${apiUrl}v1/permission/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'PER_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/group/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'GR_V',
        },
        create: {
            baseURL: `${apiUrl}v1/group/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'GR_C',
        },
        update: {
            baseURL: `${apiUrl}v1/group/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'GR_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/group/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'GR_D',
        },
        getGroupListCombobox: {
            baseURL: `${apiUrl}v1/group/list_combobox`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    news: {
        getList: {
            baseURL: `${apiUrl}v1/news/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/news/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/news/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/news/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/news/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
    },
    address: {
        getList: {
            baseURL: `${apiUrl}v1/address/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/address/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/address/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/address/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/address/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
    },
    nation: {
        getList: {
            baseURL: `${apiUrl}v1/nation/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/nation/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/nation/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/nation/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/nation/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/nation/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    settings: {
        getSettingsList: {
            baseURL: `${apiUrl}v1/setting/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SET_L',
        },
        getList: {
            baseURL: `${apiUrl}v1/setting/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SET_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/setting/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SET_V',
        },
        create: {
            baseURL: `${apiUrl}v1/setting/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'SET_C',
        },
        update: {
            baseURL: `${apiUrl}v1/setting/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'SET_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/setting/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/setting/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    customer: {
        getList: {
            baseURL: `${apiUrl}v1/customer/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'CUS_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/customer/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'CUS_V',
        },
        create: {
            baseURL: `${apiUrl}v1/customer/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'CUS_C',
        },
        update: {
            baseURL: `${apiUrl}v1/customer/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'CUS_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/customer/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'CUS_D',
        },
        changeStatus: {
            baseURL: `${apiUrl}v1/customer/change-status/:id`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'CUS_U',
        },
    },
    serverProvider: {
        getList: {
            baseURL: `${apiUrl}v1/server-provider/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SVP_L',
        },
        autoComplete: {
            baseURL: `${apiUrl}v1/server-provider/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/server-provider/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'SVP_V',
        },
        create: {
            baseURL: `${apiUrl}v1/server-provider/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'SVP_C',
        },
        update: {
            baseURL: `${apiUrl}v1/server-provider/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'SVP_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/server-provider/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'SVP_D',
        },
    },
    restaurant: {
        getList: {
            baseURL: `${apiUrl}v1/restaurant/list`,
            method: 'GET',
            site: siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'RES_L',
        },
        getListCustomer: {
            baseURL: `${apiUrl}v1/restaurant/list_by_customer`,
            method: 'GET',
            headers: baseHeader,
        },
        getListByShopAccount: {
            baseURL: `${apiUrl}v1/restaurant/list_by_custome`,
            method: 'GET',
            // site:siteSelectionPath.authentication,
            isRequiredTenantId: false,
            headers: baseHeader,
        },
        getTokenPos: {
            baseURL: `${apiUrl}v1/restaurant/get_token_pos`,
            // path: '/v1/restaurant/get_token_pos',
            method: 'GET',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/restaurant/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'RES_V',
        },
        create: {
            baseURL: `${apiUrl}v1/restaurant/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'RES_C',
        },
        update: {
            baseURL: `${apiUrl}v1/restaurant/update`,
            // path: '/v1/restaurant/update',
            method: 'PUT',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'RES_U',
        },
        updateByCustomer: {
            baseURL: `${apiUrl}v1/restaurant/update_by_customer`,
            // path: '/v1/restaurant/update_by_customer',
            method: 'PUT',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/restaurant/delete/:id`,
            method: 'DELETE',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
            permissionCode: 'RES_D',
        },
        importFood: {
            baseURL: `${apiUrl}v1/food/import`,
            // path: '/v1/food/import',
            method: 'POST',
            // site:siteSelectionPath.tenant,
            isRequiredTenantId: true,
            headers: multipartFormHeader,
        },
    },
    device: {
        getList: {
            baseURL: `${apiUrl}v1/devices/list/:restaurantId`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'D_L',
        },
        myDevicesSetting: {
            baseURL: `${apiUrl}v1/devices/my-device/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/devices/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'D_V',
        },
        create: {
            baseURL: `${apiUrl}v1/devices/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'D_C',
        },
        update: {
            baseURL: `${apiUrl}v1/devices/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'D_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/devices/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'D_D',
        },
        requestQrCode: {
            baseURL: `${apiUrl}v1/devices/request-qrcode`,
            method: 'GET',
            headers: baseHeader,
        },
        listRestaurant: {
            baseURL: `${apiUrl}v1/devices/list-restaurant`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    deviceRequest: {
        getList: {
            baseURL: `${apiUrl}v1/device-request/list/`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    inwen: {
        getList: {
            baseURL: `${apiUrl}v1/inwen-media-library/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
            permissionCode: 'IW_ME_LIB_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/inwen-media-library/get/:id`,
            method: 'GET',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_ME_LIB_V',
        },
        create: {
            baseURL: `${apiUrl}v1/inwen-media-library/create`,
            method: 'POST',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_ME_LIB_C',
        },
        update: {
            baseURL: `${apiUrl}v1/inwen-media-library/update`,
            method: 'PUT',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_ME_LIB_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/inwen-media-library/delete/:id`,
            method: `DELETE`,
            isRequiredTenantId: true,
            headers: baseHeader,
            permissionCode: 'IW_ME_LIB_D',
        },
    },
    inwenDevice: {
        getList: {
            baseURL: `${apiUrl}v1/inwen-device-admin/list`,
            method: 'GET',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_A_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/inwen-device-admin/get/:id`,
            method: 'GET',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_A_V',
        },
        create: {
            baseURL: `${apiUrl}v1/inwen-device-admin/create`,
            method: 'POST',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_A_C',
        },
        update: {
            baseURL: `${apiUrl}v1/inwen-device-admin/update`,
            method: 'PUT',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_A_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/inwen-device-admin/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: false,
            headers: baseHeader,
            permissionCode: 'IW_A_D',
        },
    },
    employee: {
        getList: {
            baseURL: `${apiPortalUrl}v1/employee/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/employee/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/employee/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/employee/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/employee/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    driver: {
        getList: {
            baseURL: `${apiPortalUrl}v1/driver/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/driver/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/driver/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/driver/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/driver/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    deliveryTrip: {
        getList: {
            baseURL: `${apiPortalUrl}v1/delivery-trip/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/delivery-trip/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    deliveryTripDetail: {
        getList: {
            baseURL: `${apiPortalUrl}v1/delivery-trip-detail/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    order: {
        getList: {
            baseURL: `${apiPortalUrl}v1/order/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        requestDeliveryQrCode: {
            baseURL: `${apiPortalUrl}v1/order/request-delivery-qrcode`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    billing: {
        getList: {
            baseURL: `${apiPortalUrl}v1/bill/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    groupFood: {
        getList: {
            baseURL: `${apiPortalUrl}v1/group_food/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/group_food/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/group_food/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/group_food/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/group_food/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    food: {
        getList: {
            baseURL: `${apiPortalUrl}v1/food/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/food/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/food/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/food/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/food/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        importMenu: {
            baseURL: `${apiPortalUrl}v1/food/import-menu`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    beilage: {
        getList: {
            baseURL: `${apiPortalUrl}v1/foodcondition/beilage-tmp-list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/foodcondition/beilage-tmp-get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/foodcondition/beilage-tmp-create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/foodcondition/beilage-tmp-update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/foodcondition/beilage-tmp-delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    ingredients: {
        getList: {
            baseURL: `${apiPortalUrl}v1/foodcondition/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/foodcondition/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/foodcondition/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/foodcondition/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiPortalUrl}v1/foodcondition/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    voucher: {
        getList: {
            baseURL: `${apiPortalUrl}v1/voucher/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiPortalUrl}v1/voucher/get/:id`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiPortalUrl}v1/voucher/create`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiPortalUrl}v1/voucher/update`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        done: {
            baseURL: `${apiPortalUrl}v1/voucher/done/:id`,
            method: 'PUT',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    voucherRedemption: {
        getList: {
            baseURL: `${apiPortalUrl}v1/voucher-redemption/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    tableRequest: {
        getList: {
            baseURL: `${apiUrl}v1/tablet-request/list`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/tablet-request/get`,
            method: 'GET',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/tablet-request/delete/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        link: {
            baseURL: `${apiUrl}v1/third-party/link-pos`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        unLink: {
            baseURL: `${apiUrl}v1/third-party/unlink-pos/:id`,
            method: 'DELETE',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
        approve: {
            baseURL: `${apiUrl}v1/tablet-request/approve`,
            method: 'POST',
            isRequiredTenantId: true,
            headers: baseHeader,
        },
    },
    thirdParty: {
        getList: {
            baseURL: `${apiUrl}v1/third-party/list`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'D_L',
        },
        getById: {
            baseURL: `${apiUrl}v1/third-party/get/:id`,
            method: 'GET',
            headers: baseHeader,
            permissionCode: 'D_V',
        },
        create: {
            baseURL: `${apiUrl}v1/third-party/create`,
            method: 'POST',
            headers: baseHeader,
            permissionCode: 'D_C',
        },
        update: {
            baseURL: `${apiUrl}v1/third-party/update`,
            method: 'PUT',
            headers: baseHeader,
            permissionCode: 'D_U',
        },
        delete: {
            baseURL: `${apiUrl}v1/third-party/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
            permissionCode: 'D_D',
        },
    },
    kitplayDevice: {
        getList: {
            baseURL: `${apiUrl}v1/kitplay-device/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/kitplay-device/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/kitplay-device/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/kitplay-device/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/kitplay-device/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/kitplay-device/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
        approveDevice: {
            baseURL: `${apiUrl}v1/kitplay-device/approve`,
            method: 'PUT',
            headers: baseHeader,
        },
        lockDevice: {
            baseURL: `${apiUrl}v1/kitplay-device/lock`,
            method: 'PUT',
            headers: baseHeader,
        },
        getByRestaurant: {
            baseURL: `${apiUrl}v1/kitplay-device/get-by-restaurant/:restaurantId`,
            method: 'GET',
            headers: baseHeader,
        },
        updateSettings: {
            baseURL: `${apiUrl}v1/kitplay-device/update-settings`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    kitplayRequest: {
        getList: {
            baseURL: `${apiUrl}v1/kitplay-request/list`,
            method: `GET`,
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/kitplay-request/get/:id`,
            method: `GET`,
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/kitplay-request`,
            method: `POST`,
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/kitplay-request/update`,
            method: `PUT`,
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/kitplay-request/delete/:id`,
            method: `DELETE`,
            headers: baseHeader,
        },
    },
    printer: {
        getList: {
            baseURL: `${apiUrl}v1/printer/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/printer/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/printer/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/printer/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/printer/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        notExist: {
            baseURL: `${apiUrl}v1/printer/printer-id/not-exist`,
            method: 'GET',
            headers: baseHeader,
        },
        getListCustomer: {
            baseURL: `${apiUrl}v1/printer/list-by-customer`,
            method: 'GET',
            headers: baseHeader,
        },
        updateSettings: {
            baseURL: `${apiUrl}v1/printer/update-settings`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    printerGroup: {
        getList: {
            baseURL: `${apiUrl}v1/printer-group/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/printer-group/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/printer-group/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/printer-group/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        updateSortingPrinterGroup: {
            baseURL: `${apiUrl}v1/printer-group/update-sort`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/printer-group/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/printer-group/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
        updateWait: {
            baseURL: `${apiUrl}v1/printer-group/update-wait`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    areas: {
        getList: {
            baseURL: `${apiUrl}v1/areas/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/areas/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/areas/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/areas/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/areas/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        autocomplete: {
            baseURL: `${apiUrl}v1/areas/auto-complete`,
            method: 'GET',
            headers: baseHeader,
        },
        updateSort: {
            baseURL: `${apiUrl}v1/areas/update-sort`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    printerMapping: {
        getList: {
            baseURL: `${apiUrl}v1/printer-mapping/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/printer-mapping/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/printer-mapping/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/printer-mapping/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/printer-mapping/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        updateSort: {
            baseURL: `${apiUrl}v1/printer-mapping/update-sort`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    systemSetting: {
        create: {
            baseURL: `${apiUrl}v1/system_setting/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/system_setting/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        getDetail: {
            baseURL: `${apiUrl}v1/system_setting/get-by-key/dpc_setting`,
            method: 'GET',
            headers: baseHeader,
        },
    },
    orderDisplay: {
        getList: {
            baseURL: `${apiUrl}v1/order-display/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/order-display/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/order-display/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/order-display/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/order-display/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
        notExist: {
            baseURL: `${apiUrl}v1/order-display/order-display-id/not-exist`,
            method: 'GET',
            headers: baseHeader,
        },
        getListCustomer: {
            baseURL: `${apiUrl}v1/order-display/list-by-customer`,
            method: 'GET',
            headers: baseHeader,
        },
        updateByCustomer: {
            baseURL: `${apiUrl}v1/order-display/update-by-customer`,
            // path: '/v1/restaurant/update_by_customer',
            method: 'PUT',
            // site:siteSelectionPath.authentication,
            headers: baseHeader,
        },
        updateSettings: {
            baseURL: `${apiUrl}v1/order-display/update-settings`,
            method: 'PUT',
            headers: baseHeader,
        },
    },
    orderDisplayMapping: {
        getList: {
            baseURL: `${apiUrl}v1/order-display-mapping/list`,
            method: 'GET',
            headers: baseHeader,
        },
        getById: {
            baseURL: `${apiUrl}v1/order-display-mapping/get/:id`,
            method: 'GET',
            headers: baseHeader,
        },
        create: {
            baseURL: `${apiUrl}v1/order-display-mapping/create`,
            method: 'POST',
            headers: baseHeader,
        },
        update: {
            baseURL: `${apiUrl}v1/order-display-mapping/update`,
            method: 'PUT',
            headers: baseHeader,
        },
        delete: {
            baseURL: `${apiUrl}v1/order-display-mapping/delete/:id`,
            method: 'DELETE',
            headers: baseHeader,
        },
    },
    templateImage: {
        getList: {
            baseURL: `${apiMediaUrl}v1/template-image/list`,
            method: 'GET',
            headers: baseHeader,
        },
    },
};

export default apiConfig;
